export default __webpack_public_path__ + "static/media/assign-icon.29a92f5d.jpg";